<template>
  <memlist-card>
    <memlist-static-table
      id="modules-table"
      :fields="headers"
      :items="moduleOptions"
    >
      <template #cell(id)="row">
        <div class="d-flex align-items-center">
          <memlist-checkbox
            :name="`checkbox-row-${row.item.id}`"
            v-model="row.item.selected"
            :title="row.item.name"
            @input="onChanged(row.item.id, $event)"
          />
          
        </div>
      </template>
    </memlist-static-table>
    <m-row class="mt-4">
      <m-col lg="12">
        <memlist-checkbox 
          v-model="all"
          :title="`Alla`"
          @input="onAllToggled"
        />
      </m-col>
    </m-row>

  </memlist-card>
</template>


<style scoped>
</style>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';


export default {
  name: 'TransactionModulesSelect',
  components: {
    
  },
  emits: ['onSelectionChanged'],
  data() {
    return {
      all: false,
      moduleOptions: [{ id: 0, selected: false, name: this.$t('COMMON.ALL') }],
      headers: [
        {
          key: 'id',
          label: 'Vald',
          thClass: 'td-short5',
          tdClass: 'td-short5'
        }
      ],
      modules: []
    };
  },
  watch: {
    
  },
  methods: {
    onAllToggled(value) {
      for (const p of this.moduleOptions) {
        p.selected = value;
      }

      this.moduleOptions = [...this.moduleOptions];
    },
    onChanged(id, val) {
      this.$emit('onSelectionChanged', this.moduleOptions);
    },
    loadModules() {
      this.modules = [
        { id: 'REGISTER', name: 'Registrering' },
        { id: 'RENEW', name: 'Förnyelse' },
        { id: 'SENDOUT', name: 'Utskick' },
        { id: 'EVENT', name: 'Evenemang' },
        { id: 'SETTLEMENT', name: 'Generell' },
        { id: 'LOGIN', name: 'Login' }
      ];

      this.moduleOptions = this.modules.map(item => ({ id: item.id, name: item.name, selected: false }));

    },
    
    reset() {
      this.all = false;
    },
    
  },
  mounted() {

    this.loadModules();
  }
};
</script>
